import { FormControl, FormControlLabel, Paper, Radio, RadioGroup, styled } from '@mui/material';

export const CustomerSatSurveyWrapper = styled(Paper)(({ theme }) => ({
    bottom: theme.spacing(4),
    right: theme.spacing(4),
    left: 'auto',
    background: 'white',
    zIndex: theme.zIndex.drawer + 1,
    border: 0,
    padding: theme.spacing(4),
    display: 'flex',
    position: 'fixed',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    outline: 0,
    boxShadow: theme.shadows[24],
    maxWidth: '400px',

    [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        left: theme.spacing(2),
    },
}));

export const StyledFormControl = styled(FormControl)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const FormButtonWrapper = styled('div')({
    width: '100%',
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const StyledCustomerSatScore = styled(FormControlLabel)(() => ({
    color: 'white',
    width: 44,
    height: 44,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 0,
    marginRight: 0,
}));

export const StyledCustomerSatScoreGroup = styled(RadioGroup)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 12,
}));

export const StyledCustomerSatScoreRadio = styled(Radio)(() => ({
    '&.MuiRadio-root': {
        display: 'none',
    },
}));
